import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Choose = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="choose">
      <div className="chooser__container container">
        <img src={Imgs.showCase} alt="chooseimg" />
        <div className="chooser__title">
          <h2>{translations[selectedLanguages].choose.title}</h2>
          <Link to="/contact">
            {translations[selectedLanguages].choose.button}
          </Link>
        </div>
        <div className="choose__context">
          <div className="choose__context-item">
            <span>01</span>
            <h3>{translations[selectedLanguages].choose.firstItemTitle}</h3>
            <p>{translations[selectedLanguages].choose.firstItemContext}</p>
          </div>
          <div className="choose__context-item">
            <span>02</span>
            <h3>{translations[selectedLanguages].choose.secondItemTitle}</h3>
            <p>{translations[selectedLanguages].choose.secondItemContext}</p>
          </div>
          <div className="choose__context-item">
            <span>03</span>
            <h3>{translations[selectedLanguages].choose.thirdItemTitle}</h3>
            <p>{translations[selectedLanguages].choose.thirdItemContext}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Choose;
